document.documentElement.classList.remove('no-js');

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-mobile-nav-toggle]');
  if (!trigger) return;
  const nav = document.querySelector('[data-mobile-nav]');
  if (!nav) return;
  nav.hidden = !nav.hidden;
  trigger.setAttribute('aria-expanded', String(!nav.hidden));
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-recommendations-url]').forEach((el) => {
    const url = el.dataset.recommendationsUrl;
    if (!url) return;
    fetch(url).then(r => r.text()).then(html => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const replacement = doc.querySelector('[data-recommendations-url]');
      if (replacement && replacement.innerHTML.trim()) el.innerHTML = replacement.innerHTML;
    }).catch(() => {});
  });
});
